import { ApproverGetAdapter } from '../../../../adapter';

export default async function ApproverGetUseCase(event) {
    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/user/get-approvers';

    const payload = {
        data: {
            userData: {}
        }
    };

    // handle request
    const result = await ApproverGetAdapter(requestUrl, JSON.stringify(payload));

    return result;
}
